const KEY = "actAs";

export const getActAs = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch { return null; }
};
export const setActAs = (v) => { if (v) sessionStorage.setItem(KEY, JSON.stringify(v)); else sessionStorage.removeItem(KEY); };

// The header is only sent while a configurator page (ActAsScope) is mounted.
let scoped = false;
export const setActScope = (v) => { scoped = v; };
export const actAsHeader = () => (scoped ? getActAs()?.id : null);

// The open configurator moves its quote to the new reseller; returns the page to reopen (or null).
let switchHook = null;
export const setSwitchHook = (fn) => { switchHook = fn; };
export const runSwitchHook = (next) => (switchHook ? switchHook(next) : Promise.resolve(null));
